import { TypographyProps } from '@mui/material';
import React from 'react';
import { SubtitleLargeBoldStyled, SubtitleLargeStyled } from 'v3/shared/typography/SubtitleLarge/styles';

export const SubtitleLarge: React.FC<TypographyProps> = (props) => {
  return (
    <SubtitleLargeStyled variant="subtitle2" {...props}>
      {props.children}
    </SubtitleLargeStyled>
  );
};

export const SubtitleLargeBold: React.FC<TypographyProps> = (props) => {
  return (
    <SubtitleLargeBoldStyled variant="subtitle2" {...props}>
      {props.children}
    </SubtitleLargeBoldStyled>
  );
};
